module.exports = __webpack_public_path__ + "static/media/stat2.eff42888.png";